import Router from '@/router';

export default {
    namespaced: true,

    state: {
        actualPipeline: [],
        actualStep: '',
    },

    actions: {
        /**
         * Navega para o próximo item do pipeline.
         */
        pushNext({
            state,
            commit,
            rootState
        }) {
            // Actual Step
            let actualStepIndex = state.actualPipeline.indexOf(state.actualStep);
            if (!state.actualPipeline[actualStepIndex])
                return;

            // Next Step
            let nextStepIndex = ++actualStepIndex;
            if (!state.actualPipeline[nextStepIndex])
                return;

            commit('setActualStep', state.actualPipeline[actualStepIndex]);

            // Navigates to the next item in the pipeline
            Router.push({ name: state.actualPipeline[nextStepIndex], query: { id: rootState.preorder.Id } });            
        },

        /**
         * Navega para o item anterior do pipeline.
         */
        pushPrevious({
            state,
            commit,
            rootState
        }) {
            // Actual Step
            let actualStepIndex = state.actualPipeline.indexOf(state.actualStep);
            if (!state.actualPipeline[actualStepIndex])
                return;

            // Previous Step
            let nextStepIndex = --actualStepIndex;
            if (!state.actualPipeline[nextStepIndex])
                return;

            commit('setActualStep', state.actualPipeline[actualStepIndex]);


            // Navigates to the previous item in the pipeline
            Router.push({ name: state.actualPipeline[nextStepIndex], query: { id: rootState.preorder.Id } });
        },

        /**
         * Navega para uma rota que pode não estar incluída no pipeline.
         * @param {String} routeName Nome da rota a ser navegada.
         */
        pushTo({
            commit,
            rootState
        }, routeName) {
            commit('setActualStep', routeName);

            // Navigates to the desired route
            Router.push( { name: routeName, query: { id: rootState.preorder.Id } } );
        },

        /**
         * Navega para a primeira rota do pipeline.
         */
        pushToFirstStep({
            commit,
            state,
            rootState
        }) {
            let firstStep = state.actualPipeline[0];
            commit('setActualStep', firstStep);

            // Navigates to the desired route
            Router.push( { name: firstStep, query: { id: rootState.preorder.Id } } );
        }
    },

    mutations: {
        /**
         * Define um novo pipeline
         * @param {String} newPipeline Novo pipeline a ser executado.
         */
        setPipeline(state, newPipeline, actualStep) {
            state.actualPipeline = newPipeline;
            state.actualStep = actualStep || newPipeline[0];
        },

        /**
         * Define o step atual
         * @param {string} actualStep Step atual do pipeline
         */
        setActualStep(state, actualStep) {
            state.actualStep = actualStep;            
        }
    }
};